export default __webpack_public_path__ + "static/media/StakingApplicationsIllustrationDark.0b6190c7.png";